// ChannelSettings — extracted verbatim from App.js.
import { useState, useEffect } from "react";
import { C } from "../lib/theme";
import { Btn, Card } from "./ui";
import { updateChannelRates } from "../data/db";

export function ChannelSettings({channel, setWorkspaces, wsId}) {
  const [commission, setCommission] = useState(((channel.commission ?? 0)*100).toFixed(2));
  const [cardFee, setCardFee]       = useState(((channel.cardFeePct ?? 0)*100).toFixed(2));
  // Subscription fee: a FIXED MONTHLY amount the aggregator charges (e.g. 250 AED/mo),
  // not a percentage. Deducted at period level from net receivable (like fixed costs),
  // with VAT applied the same way as commission/card fees.
  const [subFee, setSubFee]         = useState((channel.subscriptionFee ?? 0).toString());
  const [saving, setSaving]   = useState(false);
  const [savedAt, setSavedAt] = useState(null);

  // Resync if user switches channel
  useEffect(()=>{
    setCommission(((channel.commission ?? 0)*100).toFixed(2));
    setCardFee(((channel.cardFeePct ?? 0)*100).toFixed(2));
    setSubFee((channel.subscriptionFee ?? 0).toString());
    setSavedAt(null);
  }, [channel.id]);

  async function save(){
    setSaving(true);
    const newComm = (parseFloat(commission)||0)/100;
    const newCard = (parseFloat(cardFee)||0)/100;
    const newSub  = Math.max(0, parseFloat(subFee)||0);
    const { error } = await updateChannelRates(channel.id, {
      commission: newComm,
      card_fee_pct: newCard,
      subscription_fee: newSub,
    });
    if(!error){
      // Update local state — Overview/Insights re-render with new rates, no reload needed
      if (setWorkspaces && wsId) {
        setWorkspaces(prev => {
          const next = {...prev};
          const w = {...next[wsId]};
          w.channels = {...w.channels};
          w.channels[channel.id] = {
            ...w.channels[channel.id],
            commission: newComm,
            cardFeePct: newCard,
            subscriptionFee: newSub,
          };
          next[wsId] = w;
          return next;
        });
      } else {
        // Fallback if props missing — direct mutate
        channel.commission = newComm;
        channel.cardFeePct = newCard;
        channel.subscriptionFee = newSub;
      }
      setSavedAt(Date.now());
    }
    setSaving(false);
  }

  return (
    <div style={{marginTop:0,marginBottom:18,padding:18,borderRadius:10,background:C.bg3,border:`1px solid ${C.border2}`}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{padding:"4px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:channel.color+"18",color:channel.color,border:`1px solid ${channel.color}33`,letterSpacing:"-.1px"}}>{channel.platform}</span>
          <div>
            <div style={{fontSize:13.5,fontWeight:700,color:C.text,letterSpacing:"-.2px"}}>Channel rates</div>
            <div style={{fontSize:11.5,color:C.muted,marginTop:2,fontWeight:500}}>Commission %, card fee %, and monthly subscription fee for this platform</div>
          </div>
        </div>
        {savedAt && (Date.now()-savedAt)<3000 && (
          <span style={{fontSize:11.5,color:C.greenDark,fontWeight:700,padding:"4px 10px",borderRadius:14,background:C.green10,border:`1px solid ${C.green}33`}}>✓ Saved</span>
        )}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:12,alignItems:"end"}}>
        <div>
          <label style={{fontSize:10.5,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:.7,display:"block",marginBottom:6}}>Commission %</label>
          <input value={commission} onChange={e=>setCommission(e.target.value)} type="number" step="0.01"
            className="num"
            style={{width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13.5,fontFamily:"inherit",boxSizing:"border-box",background:"#fff",fontWeight:600,color:C.text}}/>
        </div>
        <div>
          <label style={{fontSize:10.5,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:.7,display:"block",marginBottom:6}}>Card fee %</label>
          <input value={cardFee} onChange={e=>setCardFee(e.target.value)} type="number" step="0.01"
            className="num"
            style={{width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13.5,fontFamily:"inherit",boxSizing:"border-box",background:"#fff",fontWeight:600,color:C.text}}/>
        </div>
        <div>
          <label style={{fontSize:10.5,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:.7,display:"block",marginBottom:6}}>Subscription /mo</label>
          <input value={subFee} onChange={e=>setSubFee(e.target.value)} type="number" step="0.01" min="0"
            className="num" placeholder="0"
            style={{width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13.5,fontFamily:"inherit",boxSizing:"border-box",background:"#fff",fontWeight:600,color:C.text}}/>
        </div>
        <Btn onClick={save} disabled={saving}>{saving?"Saving...":"Save rates"}</Btn>
      </div>
      <div style={{fontSize:11,color:C.muted2,marginTop:10,fontWeight:500,lineHeight:1.5}}>💡 Commission & card fee apply to new entries. Subscription fee is a fixed monthly cost deducted from net receivable (VAT applied like other fees).</div>
    </div>
  );
}
